import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { SECTION, SECTION_ADD, SECTION_DELETE } from "./actionTypes";
import {
  apiError,
  getSections,
  SectionListSuccessful,
  SectionAddSuccessful,
} from "./actions";

// AUTH related methods
import {
  postAdd,
  getList,
  postEdit,
  postDelete,
  // getRowData,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getSection() {
  try {
    const response = yield call(getList, "/masters/sections/", {});
    yield put(SectionListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

//If user is login then dispatch redux action's are directly from here.
function* AddSection({ payload: { section } }) {
  try {
    if (section.id === "") {
      const response = yield call(postAdd, "/masters/sections/", {
        code: section.code,
        name: section.name,
        createdon: new Date(section.createdon),
      });
      if (response.status === 201) {
        swal("Your Section Added Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getSections());
      } else {
        swal("Sorry! Unable to ad Section. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(SectionAddSuccessful(null));
    } else {
      const response = yield call(postEdit, "/masters/sections/" + section.id, {
        code: section.code,
        name: section.name,
        modifiedon: new Date(section.createdon),
      });
      if (response.status === 200) {
        swal("Your Section Edited Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getSections());
      } else {
        swal("Sorry! Unable to edit Location. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(SectionAddSuccessful(null));
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });
    //yield put(apiError(error));
  }
}

//If user is login then dispatch redux action's are directly from here.
function* DeleteSection(SectId) {
  try {
    const response = yield call(
      postDelete,
      "/masters/sections/" + SectId.payload.SectId
    );
    if (response.status === 204) {
      swal("Your Section has been deleted!", {
        icon: "success",
        timer: 1500,
      });
      yield put(getSections());
    } else {
      swal("Sorry! Your Section has been not deleted!", {
        icon: "error",
      });
    }
    // yield put(locationDeleteSuccessful(response.statusText))
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}

export function* watchgetSection() {
  yield takeEvery(SECTION, getSection);
}
export function* watchSectionAdd() {
  yield takeEvery(SECTION_ADD, AddSection);
}

export function* watchSectionDelete() {
  yield takeEvery(SECTION_DELETE, DeleteSection);
}

function* SectionSaga() {
  yield all([
    fork(watchgetSection),
    fork(watchSectionAdd),
    fork(watchSectionDelete),
  ]);
}

export default SectionSaga;
